import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/CalendarPage.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/rendez-vous',
    name: 'rendez-vous',
    component: () => import('@/views/AppointmentView.vue')
  },
  {
    path: '/clients',
    name: 'client',
    component: () => import('@/views/ClientView.vue')
  },
  {
    path: '/clients/:id',
    name: 'clientDetail',
    component: () => import('@/views/ClientDetailView.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/views/ServiceView.vue')
  },
  {
    path: '/parametre',
    name: 'parametre',
    component: () => import('@/views/SettingsView.vue')
  },
  {
    path: '/catégorie',
    name: 'catégorie',
    component: () => import('@/views/CatgeorieView.vue')
  },
  {
    path: '/revenue',
    name: 'revenu',
    component: () => import('@/views/RevenueView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/SignupView.vue')
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import('@/views/LegalView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
